export default __webpack_public_path__ + "static/media/icon_laudo.0847713a.svg";